// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tags-list__container {
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid #9e9e9e;
    line-height: 1.2;
}

.tags-list__tag {
    padding: 0.4rem 0.6rem;
    margin: 0.1rem 0.05rem;
    border-radius: 0.2rem;
    background: #26a69a;
    color: #fff;
    display: flex;
    align-items: center;
    flex-direction: row;
    white-space: nowrap;
}

.tags-list__tag .operator-tag__container {
    display: flex;
    flex-direction: row;
}

.operator-tag__container .operator-tag__avatar {
    border-radius: 50%;
    margin: auto 0;
    width: 1.5rem;
    height: 1.5rem;
    margin-right: 0.4rem;
}

.operator-tag__container .operator-tag__avatar svg {
    width: 100%;
    height: 100%;
}

.tags-list__tag--close {
    margin-left: 0.6rem;
    color: #fff;
    cursor: pointer;
}

.tags-list__tag--close .material-icons {
    font-size: 1.4rem;
}

.tags-list__tag--close:hover {
    color: black;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/tag-searching-input/tags-list/TagsList.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,qBAAqB;IACrB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".tags-list__container {\r\n    display: flex;\r\n    flex-direction: row;\r\n    border-bottom: 1px solid #9e9e9e;\r\n    line-height: 1.2;\r\n}\r\n\r\n.tags-list__tag {\r\n    padding: 0.4rem 0.6rem;\r\n    margin: 0.1rem 0.05rem;\r\n    border-radius: 0.2rem;\r\n    background: #26a69a;\r\n    color: #fff;\r\n    display: flex;\r\n    align-items: center;\r\n    flex-direction: row;\r\n    white-space: nowrap;\r\n}\r\n\r\n.tags-list__tag .operator-tag__container {\r\n    display: flex;\r\n    flex-direction: row;\r\n}\r\n\r\n.operator-tag__container .operator-tag__avatar {\r\n    border-radius: 50%;\r\n    margin: auto 0;\r\n    width: 1.5rem;\r\n    height: 1.5rem;\r\n    margin-right: 0.4rem;\r\n}\r\n\r\n.operator-tag__container .operator-tag__avatar svg {\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n.tags-list__tag--close {\r\n    margin-left: 0.6rem;\r\n    color: #fff;\r\n    cursor: pointer;\r\n}\r\n\r\n.tags-list__tag--close .material-icons {\r\n    font-size: 1.4rem;\r\n}\r\n\r\n.tags-list__tag--close:hover {\r\n    color: black;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
